import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import ConfirmButton from "../common/ConfirmButton";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import Loading from "../../core/Loading";
import {UserPermission} from "../../utils/utils";
import {usePermission} from "../../core/PermissionContext";
import {isUserAdmin} from "../../utils/requestUtils";

const apiUrl = Config.apiUrl;
const PaymentMethodMercadoPagoManager = (props) => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    const newEntity = {
        id: undefined,
        name: '',
        codeMercadoPago: ''

    };
    const [formData, setFormData] = useState(newEntity);

    const [loading, setLoading] = useRecoilState(loadingAtom);

    const [userAdmin, setUserAdmin] = useState(undefined);


    useEffect(() => {
        isUserAdmin().then(userAdmin => setUserAdmin(userAdmin));
    }, []);


    async function makeQuery() {
        if (id) {
            try {
                setLoading(true);
                const url = apiUrl + '/api/paymentMethodsMercadoPago/id=' + id;
                const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
                setFormData(response);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        } else {
            setFormData(newEntity);
        }

    }

    useEffect(() => {
        makeQuery();
    }, [id]);

    function validate() {

        if (!formData.name || formData.name === '') {
            alert(`Informe o nome.`);
            return false;
        }

        return true;
    }


    const onConfirm = async () => {
        if (!validate()) {
            return;
        }
        try {
            const url = apiUrl + '/api/paymentMethodsMercadoPago';
            setLoading(true);
            await makeRequest(url, id ? 'PUT' : 'POST', {
                'Content-Type': 'application/json',
                'Useruuid':Cookies.get('userUUID')
            }, JSON.stringify(formData));
            setFormData(newEntity);
            navigate('/admin/paymentmethodmercadopagolist');
        } catch (error) {
            console.error('Error adding paymentMethodMercadoPago:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };


    if (userAdmin === undefined && loadingPermissions) {
        return <Loading></Loading>;
    }
    if (userAdmin !== undefined && !userAdmin) {
        navigate('/unauthorizedaccess');
    }

    return (
        <div style={{width: '350px'}}>
            <div className="header-label">{id > 0 ? 'Editar' : 'Cadastrar'} Forma de Pagamento Mercado Pago</div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Nome:</div>
                <input type="text" value={formData.name}
                       name="name"
                       onChange={handleChange}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Código Mercado Pago:</div>
                <input type="text" value={formData.codeMercadoPago}
                       name="codeMercadoPago"
                       onChange={handleChange}/>
            </div>

            <ActionButtonsManagerView>
                <ConfirmButton onClick={onConfirm}/>
            </ActionButtonsManagerView>
        </div>
    );
};

export default PaymentMethodMercadoPagoManager; 